import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getSupportTicket, queryKeys, SupportTicket } from '@vgrubs/components';

/**
 * One ticket, for the detail modal.
 *
 * Seeded from whatever the list already knows so the modal opens with its
 * content rather than a spinner, then replaced by the fetch. The socket writes
 * into this same key, so a colleague claiming the ticket while it is open
 * changes what is on screen without anything asking.
 */
export const useSupportTicket = (ticketId: number | null) => {
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: queryKeys.supportTickets.detail(ticketId ?? 0),
    queryFn: async () => {
      const { data } = await getSupportTicket(ticketId as number);
      return data.data;
    },
    enabled: ticketId !== null,
    placeholderData: () =>
      queryClient
        .getQueriesData<{ pages: Array<{ items: SupportTicket[] }> }>({
          queryKey: queryKeys.supportTickets.listAll,
        })
        .flatMap(([, data]) => data?.pages ?? [])
        .flatMap((page) => page.items)
        .find((ticket) => ticket.id === ticketId),
  });

  return { ticket: query.data ?? null, isLoading: query.isLoading };
};
